// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"8cfef129","471":"7aa27f0f","832":"32c69527"}[chunkId] + ".css";
};